import { Either } from 'purify-ts';
import { BulkRepositoryFailure } from './failure';
import { BulkJob, BulkJobAccepted, BulkJobOptions, SendBulkProps } from './types';

export abstract class IBulkRepository {
  public abstract sendTemplateBulk(
    props: SendBulkProps
  ): Promise<Either<BulkRepositoryFailure, BulkJobAccepted>>;

  public abstract getJob(
    bulkJobId: string,
    options?: BulkJobOptions
  ): Promise<Either<BulkRepositoryFailure, BulkJob>>;
}
